import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'duration',
  pure: true
})
export class DurationPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(minutes: number): string {
    if (!minutes || minutes <= 0) return '';

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const lang = this.translate.currentLang || 'en';

    if (lang === 'ar') {
      return this.formatArabic(hours, remainingMinutes);
    } else {
      return this.formatEnglish(hours, remainingMinutes);
    }
  }

  private formatEnglish(hours: number, minutes: number): string {
    const parts: string[] = [];

    if (hours > 0) {
      const hourKey = hours === 1 ? 'meetings.hour' : 'meetings.hours';
      parts.push(`${hours} ${this.translate.instant(hourKey)}`);
    }

    if (minutes > 0) {
      const minuteKey = minutes === 1 ? 'meetings.minute' : 'meetings.minutes';
      parts.push(`${minutes} ${this.translate.instant(minuteKey)}`);
    }

    if (parts.length === 0) return '0 ' + this.translate.instant('meetings.minutes');
    if (parts.length === 1) return parts[0];
    return parts.join(` ${this.translate.instant('meetings.and')} `);
  }

  private formatArabic(hours: number, minutes: number): string {
    const parts: string[] = [];

    if (hours > 0) {
      if (hours === 1) {
        parts.push(`1 ${this.translate.instant('meetings.hour')}`);
      } else if (hours === 2) {
        parts.push(`ساعتين`);
      } else if (hours >= 3 && hours <= 10) {
        parts.push(`${hours} ${this.translate.instant('meetings.hours')}`);
      } else {
        parts.push(`${hours} ساعة`);
      }
    }

    if (minutes > 0) {
      if (minutes === 1) {
        parts.push(`دقيقة واحدة`);
      } else if (minutes === 2) {
        parts.push(`دقيقتين`);
      } else if (minutes >= 3 && minutes <= 10) {
        parts.push(`${minutes} دقائق`);
      } else {
        parts.push(`${minutes} دقيقة`);
      }
    }

    if (parts.length === 0) return '0 دقيقة';
    if (parts.length === 1) return parts[0];
    const lastPart = parts.pop();
    return parts.join(' و ') + ' و ' + lastPart;
  }
}
